import { render } from "./ActivityForms.vue?vue&type=template&id=6dff14d2&scoped=true"
import script from "./ActivityForms.vue?vue&type=script&lang=js"
export * from "./ActivityForms.vue?vue&type=script&lang=js"

import "./ActivityForms.vue?vue&type=style&index=0&id=6dff14d2&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dff14d2"]])

export default __exports__